import React from 'react';
import times from 'lodash/times';
import { HtmlTable } from '../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';

const ROWS_COUNT = 10;
const COLUMNS_COUNT = 7;

export const CampaignDetailsLoading = () => {
  return (
    <HtmlTable mb="24" variant="embedded">
      <table>
        <thead>
          <tr>
            {times(COLUMNS_COUNT).map(key => (
              <th key={key}>&nbsp;</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {times(ROWS_COUNT).map(key => (
            <tr key={key}>
              {times(COLUMNS_COUNT).map(cellKey => (
                <td key={cellKey}>
                  <Shimmer width={80} height={24} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </HtmlTable>
  );
};
